// extracted by mini-css-extract-plugin
module.exports = {"textLabelContainer":"TextLabel_textLabelContainer__b6U09","textLabel":"TextLabel_textLabel__Ja_VD"};